import { CreateNUpdateAlertModel } from './create-n-update-alert-model';
export class NewAlertDefRequest {
  public alertDef: CreateNUpdateAlertModel;

  constructor(newAlertModel: CreateNUpdateAlertModel) {
    this.alertDef = newAlertModel;
  }
}
